import api from "services/api";
import { API_URL_VERSION } from "constants/environment";
import { toSearchFilter } from "utils/utils";

export const ENDPOINT_VIOLATION_CARD_PAYMENTS = API_URL_VERSION + "pagamentos-infracoes-radar";
export const ENDPOINT_VIOLATION_CARD_PAYMENTS_LIST = ENDPOINT_VIOLATION_CARD_PAYMENTS + "/lista";
export const ENDPOINT_VIOLATION_CARD_PAYMENTS_SAVE = ENDPOINT_VIOLATION_CARD_PAYMENTS + "/salvar";
export const ENDPOINT_VIOLATION_CARD_PAYMENTS_DETAILS = ENDPOINT_VIOLATION_CARD_PAYMENTS + "/detalhes";
export const ENDPOINT_VIOLATION_CARD_PAYMENTS_FINALIZE = ENDPOINT_VIOLATION_CARD_PAYMENTS + "/finalizar";
export const ENDPOINT_VIOLATION_CARD_PAYMENTS_REMOVE = ENDPOINT_VIOLATION_CARD_PAYMENTS + "/excluir";
export const ENDPOINT_VIOLATION_CARD_PAYMENTS_PRINT = ENDPOINT_VIOLATION_CARD_PAYMENTS + "/imprimir";
export const ENDPOINT_VIOLATION_CARD_PAYMENTS_EXPORT_CARD_PAYMENT = ENDPOINT_VIOLATION_CARD_PAYMENTS + "/exportar-pagamentos-cartao";
export const ENDPOINT_VIOLATION_CARD_PAYMENTS_EXPORT_CARD_PAYMENT_VALUES = ENDPOINT_VIOLATION_CARD_PAYMENTS + "/exportar-pagamentos-cartao-valores";

export const violationCardPaymentsService = {
  list: async (params = {}) => {
    try {
      const searchParams = toSearchFilter(params);
      const response = await api.post(ENDPOINT_VIOLATION_CARD_PAYMENTS_LIST, searchParams);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "violation-card-payments.messages.errors.list";
    }
  },

  create: async (data) => {
    try {
      const response = await api.post(ENDPOINT_VIOLATION_CARD_PAYMENTS_SAVE, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "violation-card-payments.messages.errors.create";
    }
  },

  update: async (id, data) => {
    try {
      const response = await api.put(`${ENDPOINT_VIOLATION_CARD_PAYMENTS_SAVE}/${id}`, data);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "violation-card-payments.messages.errors.update";
    }
  },

  details: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_VIOLATION_CARD_PAYMENTS_DETAILS}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "violation-card-payments.messages.errors.find";
    }
  },

  finalize: async (id) => {
    try {
      const response = await api.post(`${ENDPOINT_VIOLATION_CARD_PAYMENTS_FINALIZE}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "violation-card-payments.messages.errors.finalize";
    }
  },

  remove: async (id) => {
    try {
      const response = await api.delete(`${ENDPOINT_VIOLATION_CARD_PAYMENTS_REMOVE}/${id}`);
      return response.data;
    } catch (error) {
      throw error.response?.data?.message || "violation-card-payments.messages.errors.delete";
    }
  },

  printReceipt: async (id) => {
    try {
      const response = await api.get(`${ENDPOINT_VIOLATION_CARD_PAYMENTS_PRINT}/${id}`, {
        responseType: 'blob'
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || error.response?.data?.erros_validacao || "violation-card-payments.messages.errors.print-receipt";
    }
  },

  exportCardPayments: async () => {
    try {
      const response = await api.get(ENDPOINT_EXPORT_CARD_PAYMENTS, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "violation-card-payments.messages.errors.export-card-payments";
    }
  },

  exportCardPaymentsValues: async () => {
    try {
      const response = await api.get(ENDPOINT_EXPORT_CARD_PAYMENTS_VALUES, {
        responseType: 'blob',
      });
      return response;
    } catch (error) {
      throw error.response?.data?.message || "violation-card-payments.messages.errors.export-card-payments-values";
    }
  },
};